<template>
	<el-container>
		<el-main style="padding-top: 0">
      <div style="width: 96%;margin: 0 auto">
      <div class="searchBox Cf"> <!--搜索框-->
        <el-form :model="msgSelData" ref="form" label-width="0">
          <el-form-item label="">
            <el-input size="mini" v-model="msgSelData.keyword" clearable placeholder="客服id/客户id/客户手机号" suffix-icon="el-icon-search" @input="inputContent"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="msgSelData.claimStatus" clearable placeholder="请选择 认领状态" size="mini" style="width: 100%;">
              <el-option
                  v-for="item in claimData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="msgSelData.trackStatus" clearable placeholder="请选择 跟踪状态" size="mini" style="width: 100%;">
              <el-option
                  v-for="item in trackData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="0">
            <el-select v-model="msgSelData.timeData" clearable placeholder="请选择 时间段" size="mini" style="width: 100%;">
              <el-option
                  v-for="item in timeData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="primary" size="mini" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
			<el-table 
			:data="tableData"
			border
			highlight-current-row
			row-key="wechat"
			style="width: 100%;"
			:header-cell-style="headerStyle"
			:cell-style="cellStyle"
      :max-height="tableHeight"
			>	
				<el-table-column property="uid" label="客户id" width="100" show-overflow-tooltip></el-table-column>
				<el-table-column property="uname" label="客户姓名"  show-overflow-tooltip></el-table-column>
				<el-table-column property="address" label="归属地" width="100" show-overflow-tooltip></el-table-column>
				<el-table-column property="wechat" label="微信号" show-overflow-tooltip></el-table-column>
				<el-table-column property="tel" label="手机号" show-overflow-tooltip></el-table-column>
				<el-table-column property="remarks" label="备注" show-overflow-tooltip></el-table-column>
				<el-table-column property="createTime" label="留言时间" show-overflow-tooltip></el-table-column>
				<el-table-column property="claimStatus" label="认领状态" width="110" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button v-if="scope.row.claimStatus==1" type="text" size="small" 
						style="color: #00FF00;" @click="clickIsClaimed(scope.row.mid,scope.row.claimStatus)">{{scope.row.isClaim}}</el-button>
						<el-button v-else type="text" size="small" @click="clickIsClaimed(scope.row.mid,scope.row.claimStatus)">{{scope.row.isClaim}}</el-button>
					</template>
				</el-table-column>
				<el-table-column property="csRealName" label="认领客服" show-overflow-tooltip></el-table-column>
				<el-table-column property="claimTime" label="认领时间" show-overflow-tooltip></el-table-column>
			</el-table>
			<div style="display: flex;flex-direction: row;width: 60%;margin-left: 20%;justify-content: space-around;margin-top: 20px;">
				<el-pagination background :pager-count='9' :page-size="10"  layout="prev, pager, next, total"  :total="total" @prev-click="pre" @next-click="next" @current-change="handleCurrentChange"> </el-pagination>
			</div>
      </div>
			<div v-show="claimed" class="dialog_box">
				<el-dialog :visible.sync="claimed" center :close-on-click-modal="false" :close-on-press-escape="false" width="20%" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
					<div style="text-align: center;">此用户已被认领，不可重复操作！</div>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="claimedCondirm">确 定</el-button>
					</div>
				</el-dialog>
			</div>
			<div v-show="notClaimed" class="dialog_box">
				<el-dialog :visible.sync="notClaimed" center :close-on-click-modal="false" :close-on-press-escape="false" width="20%" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
					<div style="text-align: center;">请确认是否认领此用户，认领后不可取消？</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="notClaimed = false">取 消</el-button>
						<el-button type="primary" @click="claimCondirm">确 定</el-button>
					</div>
				</el-dialog>
			</div>
		</el-main>
	</el-container>		
</template>

<script>

import $ from "jquery";

export default{
	data(){
		return {
			mid:'',
			csid:'',
			total:0,
			input1:'',
			claimStatus:null,
			trackStatus:null,
			claimed:false,
			notClaimed:false,
			queryTime:0,
			claimData:[{
				value:0,
				label: '未认领'
			},{
				value:1,
				label: '已认领'
			}],
			trackData:[{
				value:0,
				label: '未跟踪'
			},{
				value:1,
				label: '已跟踪'
			}],
			timeData:[{
				value:1,
				label:'近一天'
			},{
				value:3,
				label:'近三天'
			},{
				value:7,
				label:'一周内'
			},{
				value:30,
				label:'一月内'
			},
			],
			msgSelData:{
				keyword:'',
				claimStatus:null,
				trackStatus:null,
				queryTime:null,
				page:1,
				size:10
			},
			tableData:[],
			page:1,
      tableHeight:500
		};
	},
	mounted() {
		console.log("MsgManager Mounted---")
		this.messageSel()
    this.$nextTick(() => {
      var seaH = $(".searchBox").height();
      this.tableHeight = window.innerHeight - seaH -180;
      window.addEventListener('resize', () => { //监听浏览器窗口大小改变
        //浏览器变化执行动作
        var seaH = $(".searchBox").height();
        this.tableHeight = window.innerHeight - seaH -180;
      });
    })
	},
	methods:{
		headerStyle({ row, column, rowIndex, columnIndex }) {
			console.log(row, column, rowIndex, columnIndex);
			return 'text-align:left;padding:15px;';
			
		},
		cellStyle({ row, column, rowIndex, columnIndex }) {
			console.log(row, column, rowIndex, columnIndex);

			return 'text-align:left;padding:15px;';

		},
		inputContent(value){
			console.log("Input Something---")
			console.log(value)
		},
		search(){
			this.messageSel()
			this.msgSelData={
				keyword:'',
				claimStatus:null,
				trackStatus:null,
				queryTime:null,
				page:1,
				size:10
			}
		},
		async messageSel(){
			console.log("Message Select")
			// console.log(this.noRoot)
			// console.log(this.isRoot)
			var api = "/manager/message/queryMessage"
			const response=await this.util.postRequest({
				url:api,
				method:"POST",
				data:this.msgSelData
			})
			this.tableData=response.data.list
			for(var i=0; i<this.tableData.length; i++ ){
				this.tableData[i].isClaim=this.tableData[i].claimStatus==1?"已认领":"未认领"
				if(this.tableData[i].createTime){
					this.tableData[i].createTime = this.util.timeStampToDate(this.tableData[i].createTime*1000 , 0)
				}
				if(this.tableData[i].claimTime){
					this.tableData[i].claimTime = this.util.timeStampToDate(this.tableData[i].claimTime*1000 , 0)
				}
			}
			this.total = response.data.total
			console.log("留言数据",this.tableData)
		},
		clickIsClaimed(mid,status){
			if(status==1){
				this.claimed=true
				this.notClaimed=false
			}else if(status==0){
				this.notClaimed=true
				this.claimed=false
				this.csid = this.util.getLocalId()
				this.mid = mid
			}
		},
		claimedCondirm(){
			this.claimed=false
		},
		async claimCondirm(){
			this.notClaimed=false
			var api = "/manager/message/claimMessage"
			const response=await this.util.postRequest({
				url:api,
				method: "POST",
				data:{
					csid:this.csid,
					mid:this.mid
				},
			})
			if(response.resultCode==="10000"){
				this.messageSel()
			}else{
				this.$message.error(response.desc)
			}
		},
		pre(info) {
			console.log("pre：",info)
			this.msgSelData.page = info
			this.messageSel()
		},
		next(info) {
			console.log("next：",info)
			this.msgSelData.page = info
			this.messageSel()
		},
		handleCurrentChange(val) {
			this.start = 4*(val-1)
			console.log("当前页码：",val,this.start)
			this.msgSelData.page = val
			this.messageSel()
		},
	}
}
</script>

<style>

</style>
